import { render } from "./IconDownload.vue?vue&type=template&id=2bf3dea8"
import script from "./IconDownload.vue?vue&type=script&lang=js"
export * from "./IconDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__